import React from "react";

type Props = {};

const Notification = (props: Props) => {
  return <div>Notification</div>;
};

export default Notification;
